// extracted by mini-css-extract-plugin
module.exports = {"IntroductionCard":"IntroductionCard___1gEUz","IntroductionCard_hasDate":"IntroductionCard_hasDate___o_Gtw"};